"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adjustFontSize = void 0;
const adjustFontSize = (text, maxFontSize, minFontSize, textLengthThreshold) => {
  let fontSize = maxFontSize;
  const textLength = text.length;
  if (textLength > textLengthThreshold) {
    fontSize = maxFontSize - (textLength * 1.1 - textLengthThreshold);
    fontSize = Math.max(minFontSize, fontSize);
  }
  return fontSize;
};
exports.adjustFontSize = adjustFontSize;